<template>
<div class="">
    <GmapMap ref="mapRef"
        :center='center'
        :zoom='5'
        style='width:100%;  height: 69vh;'
        :options=getOptions()
    >

    <!--template v-for="(m, index) in gmapmarkers">

      <gmap-custom-marker :marker="m">
      <img src="/static/images/green_pin.png" />
      </gmap-custom-marker>

    </template-->


        <!--GmapCluster
            :position="center"
            :clickable="true"
            :animation="2"
            :imagePath='"../static/images/"'
            @mouseover="openInfoWindow($event, 'cluster')"
            @mouseout="closeinfowindow()"
            -->
            <GmapMarker
                :key="index"
                v-for="(m, index) in gmapmarkers"
                :position="m.position"
                :clickable="true"
                :name="m.name"
                :draggable="false"
                :options="m.option"
                :icon="{ url: m.iconUrl
                 }"
                @mouseover="openInfoWindow(m, 'marker')"
                @mouseout="closeinfowindow()"
            />

            <!--img src="/../static/images/green_pin.png" /-->
            <gmap-info-window :options="{
              maxWidth: 300,
              pixelOffset: { width: 0, height: -35 }
              }"
              :position="infoWindow.position"
              :opened="infoWindow.open"
              @closeclick="infoWindow.open=false">
                <div v-html="infoWindow.template"></div>
            </gmap-info-window>
        <!--/GmapCluster-->
    </GmapMap>
</div>
</template>

<script>
var app="";
import { gmapApi } from 'gmap-vue';
import GmapCustomMarker from 'vue2-gmap-custom-marker';


export default {
  name: 'GoogleMap',
  mounted () {
    app=this;
  },
  components: {
      'gmap-custom-marker': GmapCustomMarker
  },
  props: ['gmapmarkers', 'soldUnit'],
  data() {
    return {
        center: { lat: -25.324167, lng: 136.011221 },
        markers: [],
        infoWindow: {
          position: {lat: 0, lng: 0},
          open: false,
          template: ''
        },
    }
  },
  methods: {
    getOptions() {
      return {
          zoomControl: true,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: true,
          disableDefaultUi: false
        };
    },
    closeinfowindow(){
      app.infoWindow.open=false;
    },
    openInfoWindow(event, type) {
      // console.log(app.soldUnit);
        if(type == 'marker') {
          app.infoWindow.position = { lat: event.position.lat, lng: event.position.lng };
          app.infoWindow.template = `<b>Manufacturer: ${event.option.name}</b><br><b>Sold Unit:</b>${app.soldUnit}
          <br><b>LGA:</b> ${event.option.lga_name} <br><b>Market Share:</b> ${event.option.market_share} <br><b>Postcode:</b> ${event.option.postcode}
          <br><b>Total LGA Units:</b> ${event.lga_count}<br>`;
          app.infoWindow.open = true;
        } else {
          let markers = event.getMarkers();
          let vehicleTypeList = [];
          if(markers) {
            var isClusteronSamePostcode=true;
            var postcode="";
            markers.forEach(element => {
              if(!postcode) {
                postcode=element.postcode;
              }
              if(postcode != element.postcode && isClusteronSamePostcode) {
                isClusteronSamePostcode =  false;
              }
              if(vehicleTypeList.length == 0) {
                vehicleTypeList.push({"name": element.name, "purchasedUnit" :1, "lga_name" : element.lga_name, "lga_count" : element.lga_count
                , "market_share" : element.market_share, 'iscompetitor' : element.iscompetitor, 'postcode' : element.postcode});
              } else {
                let elementFound = false;
                for(var i=0; i < vehicleTypeList.length; i++){

                  if(vehicleTypeList[i].postcode === element.postcode){
                      vehicleTypeList[i].purchasedUnit = vehicleTypeList[i].purchasedUnit + 1;
                      elementFound = true;
                      break;
                  }
                }
                if(!elementFound) {
                  vehicleTypeList.push({"name": element.name, "purchasedUnit" :1, "lga_name" : element.lga_name, "lga_count" : element.lga_count
                , "market_share" : element.market_share, 'iscompetitor' : element.iscompetitor , 'postcode' : element.postcode});
                }
              }
            });
            if(markers.length>0) {
              app.infoWindow.position = { lat: markers[0].lat, lng: markers[0].lng };
              if(vehicleTypeList.length>0) {
                // Sort by is competitor show first
                vehicleTypeList.sort((a,b) => (a.iscompetitor > b.iscompetitor) ? 1 : ((b.iscompetitor > a.iscompetitor) ? -1 : 0))

                app.infoWindow.template = "";
                vehicleTypeList.forEach(element => {

                  app.infoWindow.template += `<b>Manufacturer: ${element.name}</b>
                  <br>Sold Unit: ${app.soldUnit}<br>LGA: ${element.lga_name}<br>Market Share:
                  ${element.market_share}<br>
                  <br>Total LGA Units:
                  ${element.lga_count}<br><br>`;
                });
                if(isClusteronSamePostcode) {
                  app.infoWindow.template += `<br><br><b>Postcode: ${postcode}</b>`;
                }
                app.infoWindow.open = true;
              }
            }
          }
        }
      },
  },
  computed: {
    // The below example is the same as writing
    // google() {
    //   return gmapApi();
    // },
    google: gmapApi,
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/GoogleMap.vue